module.exports = __webpack_public_path__ + "img/CG1_49.e0284d5.png";